export default __webpack_public_path__ + "static/media/4-discovery.891ef7fc.png";